module.exports = __webpack_public_path__ + "img/AstroFrens189.c19ab2d2.jpg";